<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2 [innTemplate]="enviarTemplateEdit" [modulo]="'Balanza'" [tituloCard]="'Reporte de Ticket de garita'"
      [titulo]="'Reporte de Ticket de Autorización de Ingreso por Garitas'">
    </app-lfsa-card-v2>
    
    <ng-template #enviarTemplateEdit>
        <section class="section">
            <form [formGroup]="agregarForm" class="form-group" novalidate>
                <div class="row">
                    <div class="form-group col-md-3">
                        <app-lfsa-combo-box [comboBox]="cmbxTipo" [control]="agregarForm.get('tipo') | formControl"
                            [idOpcion]="'clave'" [id]="'tipo'" [label]="'Tipo *'" [opcion]="'valor'"
                            formControlName="tipo" >
                        </app-lfsa-combo-box>
                    </div>

                    <div class="form-group col-md-3">
                        <app-lfsa-combo-box [comboBox]="cmbxGarita" [control]="agregarForm.get('garitaId') | formControl"
                            [idOpcion]="'idGarita'" [id]="'garitaId'" [label]="'Seleccione Garita *'" [opcion]="'desca'"
                            formControlName="garitaId" >
                        </app-lfsa-combo-box>
                    </div>

                    <div class="form-group col-md-3">
                        <app-lfsa-input [control]="agregarForm.get('idTicket') | formControl" [id]="'idTicket'" [isReadOnly]="false"
                            [label]="'Ticket de Garita'" [mostrarImg]="false" [placeholder]="'Ticket de Garita'" [rutaImagen]="" [type]="'number'"
                            formControlName="idTicket">
                        </app-lfsa-input>
                    </div>

                    <div class="form-group col-md-3">
                        <app-lfsa-input [control]="agregarForm.get('ticketId') | formControl" [id]="'ticketId'" [isReadOnly]="false"
                            [label]="'Ticket de Garita Origen'" [mostrarImg]="false" [placeholder]="'Ticket de Garita Origen'" [rutaImagen]="" [type]="'number'"
                            formControlName="ticketId">
                        </app-lfsa-input>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-md-3">
                    <app-lfsa-input [control]="agregarForm.get('proveedorTranspId') | formControl" [id]="'proveedorTranspId'" [isReadOnly]="false"
                        [label]="'Proveedor transporte'" [mostrarImg]="false" [placeholder]="'Proveedor de Transporte'" [rutaImagen]="" [type]="'text'"
                        formControlName="proveedorTranspId">
                    </app-lfsa-input>
                    </div>

                    <div class="form-group col-md-3">
                    <app-lfsa-input [control]="agregarForm.get('fechaInicio') | formControl" [id]="'fechaInicio'" [label]="'Fecha Iinicio'"
                        [mostrarImg]="false" [placeholder]="'fechaInicio'" [rutaImagen]="" [type]="'date'" formControlName="fechaInicio">
                    </app-lfsa-input>
                    </div>

                    <div class="form-group col-md-3">
                    <app-lfsa-input [control]="agregarForm.get('fechaFin') | formControl" [id]="'fechaFin'" [label]="'Fecha Fin'"
                        [mostrarImg]="false" [placeholder]="'fechaFin'" [rutaImagen]="" [type]="'date'" formControlName="fechaFin">
                    </app-lfsa-input>
                    </div>

                </div>

                <div class="row">
                    <!--
                    <div class="form-group col-md-3 d-flex align-items-center"></div>
                    <div class="form-group col-md-3 d-flex align-items-center"></div>
                    -->
                    <div class="col-md-5 d-flex align-items-center">
                        <div class="btn-group" role="group" aria-label="Basic mixed styles">
                            <button (click)="resetCampos()" type="button" class="btn btn-warning"><i class="fas fa-redo-alt"></i> Reset </button>
                            <button (click)="buscarReporte()" type="button" class="btn btn-info"><i class="fas fa-search"></i> Buscar </button>
                            <button (click)="descargarExcel()" type="button" class="btn btn-success"><i class="fas fa-arrow-alt-circle-down"></i> Descargar </button>
                        </div>
                    </div>
                </div>
                <br>

            </form>

        <div class="row">
          <div class="col-md-12 ">
            <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
            <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="'ag-theme-balham'"
              [columnDefs]="columnDefs" [frameworkComponents]="frameworkComponents"
              [id]="DAT_AG_GRID.id" [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
              [pagination]="true" [rowData]="rowData">
            </ag-grid-angular>
          </div>
        </div>

      </section>
    </ng-template>
  </div>